import React from 'react';
import { View } from 'react-native';
import QuestionButton from '../Buttons/QuestionButton';
import RegularText from '../Text/RegularText';
import LoadingBar from './LoadingBar';

const LoadingPopup = ({
  onPressed,
  title,
  isLoading,
}) => (
  <View style={{
    padding: 32,
    width: 464,
    minHeight: 170,
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 2,
    backgroundColor: '#fff',
    borderRadius: 8,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.22,
    shadowRadius: 12,
    textAlign: 'left',
  }}
  >
    <RegularText marginBottom={25}>{title}</RegularText>
    <LoadingBar isLoading={isLoading} />
    {!isLoading && (
    <View style={{ alignItems: 'flex-end', flex: 'right', marginTop: 25 }}>
      <QuestionButton onPress={onPressed} leftButtonText="Close" isHallow smallButton marginRight={0} />
    </View>
    )}
  </View>
);

export default LoadingPopup;
